import axiosInstance from './axios';

export interface LoginCredentials {
    username: string;
    password: string;
}

export interface User {
    id: number;
    username: string;
    role: string;
    fullName: string | null;
    email: string | null;
}

export interface LoginResponse {
    token: string;
    user: User;
}

export const login = async (credentials: LoginCredentials): Promise<LoginResponse> => {
    try {
        const response = await axiosInstance.post('/api/login', credentials);
        return response.data;
    } catch (error: any) {
        console.error('Login error:', error.response?.data || error.message);
        if (error.response) {
            throw new Error(error.response.data.error || 'Login failed');
        }
        throw new Error('Network error occurred');
    }
};

export const setAuthToken = (token: string | null) => {
    if (token) {
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        localStorage.setItem('token', token);
    } else {
        delete axiosInstance.defaults.headers.common['Authorization'];
        localStorage.removeItem('token');
    }
};

/**
 * Clear auth data and log the user out
 */
export const logout = () => {
    setAuthToken(null);
    localStorage.removeItem('user');
    // Redirect to login page
    window.location.href = '/login';
};

/**
 * Request a new token from the server using the auth token endpoint
 * Returns true if token was successfully refreshed
 */
export const refreshToken = async (): Promise<boolean> => {
    try {
        // Get stored user data (needed for re-login if token refresh fails)
        const userData = localStorage.getItem('user');
        if (!userData) {
            console.error('No user data found during token refresh');
            return false;
        }

        // Call the token refresh endpoint
        const response = await axiosInstance.get('/api/token');
        
        if (response.data && response.data.token) {
            // Store the new token
            setAuthToken(response.data.token);
            console.log('Token refreshed successfully');
            return true;
        } else {
            console.error('No token received during refresh');
            return false;
        }
    } catch (error) {
        console.error('Error refreshing token:', error);
        return false;
    }
};
